"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useNamedSettingsMenu = void 0;
const named_settings_context_1 = require("../../../settings/named/named-settings-context");
const react_1 = require("react");
const react_intl_1 = require("react-intl");
const snackbar_context_1 = require("../../snackbar/snackbar-context");
const snackbar_types_1 = require("../../snackbar/snackbar-types");
const user_context_1 = require("../../../providers/user/user-context");
const event_callback_hook_1 = require("../../../utils/event-callback-hook");
const table_context_1 = require("../table-context");
function useNamedSettingsMenu(tag) {
    var _a;
    const { getNamedSettings, saveNamedSettings, deleteNamedSettings } = (0, react_1.useContext)(named_settings_context_1.NamedSettingsContext);
    const { showSnackbar } = (0, react_1.useContext)(snackbar_context_1.SnackbarContext);
    const { user } = (0, react_1.useContext)(user_context_1.UserContext);
    const { filtersState, setFiltersState, columnsState, setColumnsState, sorts, setSorts, } = (0, react_1.useContext)(table_context_1.TableContext);
    const intl = (0, react_intl_1.useIntl)();
    const [opened, setOpened] = (0, react_1.useState)(false);
    const [savedItems, setSavedItems] = (0, react_1.useState)([]);
    const [selectedItem, setSelectedItem] = (0, react_1.useState)(null);
    const confirmDeleteDialog = (0, react_1.useRef)(null);
    const createDialog = (0, react_1.useRef)(null);
    const selectSaved = (0, event_callback_hook_1.useEventCallback)((settings) => {
        setSelectedItem((saved) => {
            if (saved === settings.id) {
                setFiltersState((filtersState) => {
                    return filtersState.map((state) => ({
                        ...state,
                        value: null,
                        enabled: false,
                        object: null,
                        filters: [],
                        selectFilter: [],
                        numberFilter: null,
                    }));
                });
                return null;
            }
            const parsed = JSON.parse(settings.settings);
            if (parsed.filtersState != null) {
                setFiltersState(parsed.filtersState);
            }
            if (parsed.columnsState != null) {
                setColumnsState(parsed.columnsState);
            }
            if (parsed.sorts != null) {
                setSorts(parsed.sorts);
            }
            return settings.id;
        });
    });
    const load = (0, react_1.useCallback)(async () => {
        const settings = await getNamedSettings(tag);
        setSavedItems(settings);
    }, [getNamedSettings, tag]);
    const createSaved = (0, event_callback_hook_1.useEventCallback)(async (settings) => {
        const parsed = {
            filtersState,
            columnsState,
            sorts,
        };
        settings.settings = JSON.stringify(parsed);
        settings.tag = tag;
        settings = await saveNamedSettings(settings);
        setSelectedItem(settings.id);
        const message = intl.formatMessage({
            id: 'EAS_TABLE_SAVED_SAVE_SUCCESS',
            defaultMessage: 'Nastavení uloženo',
        });
        showSnackbar(message, snackbar_types_1.SnackbarVariant.SUCCESS);
        await load();
    });
    const updateSaved = (0, event_callback_hook_1.useEventCallback)(async () => {
        const selectedSettings = savedItems.find((item) => item.id === selectedItem);
        if (selectedItem && selectedSettings) {
            await deleteNamedSettings(selectedItem);
            await createSaved(selectedSettings);
            const message = intl.formatMessage({
                id: 'EAS_TABLE_SAVED_UPDATE_SUCCESS',
                defaultMessage: 'Nastavení uloženo',
            });
            showSnackbar(message, snackbar_types_1.SnackbarVariant.SUCCESS);
        }
    });
    const deleteSaved = (0, event_callback_hook_1.useEventCallback)(async (id) => {
        await deleteNamedSettings(id);
        setSelectedItem(null);
        const message = intl.formatMessage({
            id: 'EAS_TABLE_SAVED_DELETE_SUCCESS',
            defaultMessage: 'Nastavení odstraněno',
        });
        showSnackbar(message, snackbar_types_1.SnackbarVariant.SUCCESS);
        await load();
    });
    const openMenu = (0, react_1.useCallback)(() => {
        setOpened(true);
    }, []);
    const closeMenu = (0, react_1.useCallback)(() => {
        setOpened(false);
    }, []);
    (0, react_1.useEffect)(() => {
        load();
    }, [load]);
    const selected = savedItems.find((item) => item.id === selectedItem);
    const isAuthor = ((_a = selected === null || selected === void 0 ? void 0 : selected.user) === null || _a === void 0 ? void 0 : _a.id) === (user === null || user === void 0 ? void 0 : user.id);
    const canEdit = isAuthor;
    return {
        opened,
        openMenu,
        closeMenu,
        savedItems,
        selectSaved,
        createSaved,
        updateSaved,
        deleteSaved,
        selectedItem,
        confirmDeleteDialog,
        createDialog,
        canEdit,
    };
}
exports.useNamedSettingsMenu = useNamedSettingsMenu;
//# sourceMappingURL=named-settings-hook.js.map